import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loggedinbar"
}

import { UserData } from "@/api/UserData";
import Loader from "@/components/MainLoader.vue";
import { ref, computed, Ref, ComputedRef, onBeforeMount } from "vue";
import { useUserStore } from "@/stores/root/users";
import { storeToRefs } from "pinia";
import { useQuoteStore } from "@/stores/root/quote";
import { checkUserStatus } from "@/utils/Utils";


export default /*@__PURE__*/_defineComponent({
  __name: 'LoggedInBar',
  setup(__props) {

const userStore = storeToRefs(useUserStore());
const loading: Ref<boolean> = ref(false);
const user = userStore.user;
const quote = useQuoteStore();
const userLoggedIn: ComputedRef<boolean> = computed(() => {
  return user.value.loggedIn;
});

// onBeforeMount(() => {
//   checkUserStatus();
// });

const userName: ComputedRef<string> = computed(() => {
  return (
    user.value.firstName[0].toUpperCase() +
    user.value.firstName.slice(1) +
    " " +
    user.value.lastName[0].toUpperCase() +
    user.value.lastName.slice(1)
  );
});

const logoutUser = async () => {
  loading.value = true;
  const result = await UserData.logout();
  loading.value = false;
  if (result.error) {
    console.log("User logout error: %o", result.message);
  } else {
    user.value.email = "";
    user.value.firstName = "";
    user.value.lastName = "";
    user.value.entityId = 0;
    user.value.loggedIn = false;
    //userStore.logout;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Loader, { loading: loading.value }, null, 8, ["loading"]),
    (userLoggedIn.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createTextVNode(_toDisplayString(userName.value) + " ", 1),
          _createElementVNode("a", {
            href: "#",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (logoutUser()), ["prevent"]))
          }, "Logout")
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})